export default {
  product: {
    name: 'Cumpără card cadou',
  },
  description: {
    items: {
      delivery: 'Trimis imediat prin e-mail ca PDF',
      usage: {
        online: 'Utilizabil doar online',
        online_and_store: 'Utilizabil online și la restaurant',
      },
      value: 'Sume flexibile de la {{from}} la {{to}}',
    },
  },
};
